:host {
	display: block;
}
:host[hidden] {
	display: none;
}
:host > .smoothly-notifier-wrapper {
	pointer-events: none;
	display: flex;
	flex-wrap: wrap-reverse;
	align-content: stretch;
	position: fixed;
	bottom: 3rem;
	left: 0;
	text-align: center;
	z-index: 100;
}

:host > .smoothly-notifier-wrapper > smoothly-notification {
	pointer-events: all;
}
